import { defineAction, object, string, enumerated } from '~/prix'
import fetchShapesFromOpenStreetMapAction from './fetchShapesFromOpenStreetMap.action.json'

const fetchShapesFromOpenStreetMapDefinition = defineAction({
  ...fetchShapesFromOpenStreetMapAction,
  input: object({
    level: enumerated({
      macroRegion: 'macroRegion',
      mesoRegion: 'mesoRegion',
      microRegion: 'microRegion',
      state: 'state',
      city: 'city',
    }).isOptional(),
    ibgeCodes: string(),
  }),
  output: object({}),
})

export default fetchShapesFromOpenStreetMapDefinition
